import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
} from "react-router-dom";
import Layout from "@components/Layout";
import HomePage from "@pages/HomePage";
import AboutPage from "@pages/AboutPage";
import ToursPage from "@pages/ToursPage";
import TourDetailPage from "@pages/TourDetailPage";
import ActivitiesPage from "@pages/ActivitiesPage";
import VehiclesPage from "@pages/VehiclesPage";
import VehicleDetailPage from "@pages/VehicleDetailPage";
import ContactPage from "@pages/ContactPage";
import FAQPage from "@pages/FAQPage";
import TermsPage from "@pages/TermsPage";
import NotFoundPage from "@pages/NotFoundPage";
import WhatsAppButton from "@components/WhatsAppButton";

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <WhatsAppButton />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Layout />
        <ScrollRestoration />
      </>
    ),
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "tours",
        element: <ToursPage />,
      },
      {
        path: "tours/:region",
        element: <TourDetailPage />,
      },
      {
        path: "activities",
        element: <ActivitiesPage />,
      },
      {
        path: "vehicles",
        element: <VehiclesPage />,
      },
      {
        path: "vehicles/:type",
        element: <VehicleDetailPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "faq",
        element: <FAQPage />,
      },
      {
        path: "terms",
        element: <TermsPage />,
      },
      // Catch-all for unknown URLs. Renders the 404 UI client-side; pair with
      // an Amplify rewrite of `/<*>` → `/index.html` at status `404` (NOT
      // `404-200`) so crawlers still see a real HTTP 404 — see docs/HOSTING.md.
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default App;
